<template>
    <div>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-md-3 mb-2 mb-md-0 pills-stacked">
                    <ul class="nav nav-pills flex-column">
                        <li class="nav-item" @click="setComponent('profileForm')">
                            <a class="nav-link d-flex align-items-center" :class="[{active:component == 'profileForm'}]" >
                                <i><font-awesome-icon :icon="['fas', 'cog']"/></i>
                                <span>{{$t('message.common_data')}}</span>
                            </a>
                        </li>
                        <li class="nav-item" @click="setComponent('chPassForm')">
                           <a class="nav-link d-flex align-items-center" :class="[{active:component == 'chPassForm'}]" >
                                <i><font-awesome-icon :icon="['fas', 'lock']"/></i>
                                <span>{{$t('message.change_password')}}</span>
                            </a>
                        </li>
                        <li class="nav-item" @click="setComponent('chEmailForm')">
                           <a class="nav-link d-flex align-items-center" :class="[{active:component == 'chEmailForm'}]" >
                                <i><font-awesome-icon :icon="['fas', 'at']"/></i>
                                <span>{{$t('message.change_email')}}</span>
                            </a>
                        </li>
                        <li class="nav-item" @click="setComponent('chPhoneForm')">
                           <a class="nav-link d-flex align-items-center" :class="[{active:component == 'chPhoneForm'}]" >
                                <i><font-awesome-icon :icon="['fas', 'phone']"/></i>
                                <span>{{$t('message.change_phone')}}</span>
                            </a>
                        </li>
                        
                    </ul>
                </div>
                <div class="col-md-9">
                    <cardWrapper>
                        <component :is="component" @action_success="success"></component>
                    </cardWrapper>       
                </div>
            </div>
        </div>
    </div>   
        </div>

</template>                                                
<script>
    import cardWrapper from '@/components/cardWrapper';
    import profileForm from '@/forms/profile_form';
    import chPassForm from '@/forms/ch_pass_form';
    import chEmailForm from '@/forms/ch_email_form';
    import chPhoneForm from '@/forms/ch_phone_form';
    
    export default{
        name: 'profile',
        data() {
            return{
                component:'profileForm'

            }
        },
        components:{
            cardWrapper,
            profileForm,
            chPassForm,
            chEmailForm,
            chPhoneForm
        },
        methods: {
           
           
            setComponent:function (component) {
                this.component = component
            },
            success:function () {
                 this.component = profileForm
            }
        },
        
        

    }
</script>
<style>
    .nav-item{
        cursor: pointer;
    }
</style>    